import { styled } from '@mui/material/styles';
import { HEADER, NAVBAR } from '../../config';

export const styles = {
  box: {
    display: { lg: 'flex' },
    minHeight: { lg: 1 },
  },
};

type MainStyleProps = {
  collapseClick: boolean;
  isMasquerade: boolean;
};

export const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick' && prop !== 'isMasquerade',
})<MainStyleProps>(({ collapseClick, theme, isMasquerade }) => ({
  flexGrow: 1,
  paddingTop: HEADER.DASHBOARD_MOBILE_OFFSET_HEIGHT + (isMasquerade ? 80 : 34),
  paddingBottom: 40,
  backgroundColor: theme.palette.grey[200],
  minWidth: '1060px',
  width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
  transition: theme.transitions.create('margin-left', {
    duration: theme.transitions.duration.shorter,
  }),
  ...(collapseClick && {
    marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
  }),
  [theme.breakpoints.up('lg')]: {
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + (isMasquerade ? 80 : 34),
    paddingRight: 16,
    paddingLeft: 16,
  },
  [theme.breakpoints.down('xl')]: {
    width: `calc(100% - ${NAVBAR.DASHBOARD_NARROW_WIDTH}px)`,
  },
}));
